// UI strings for the three supported languages.
// Article content itself comes from the backend per-translation.
const UI = {
  en: {
    site_name: "Middle East Center for Security and Counter-Extremism",
    site_short: "MESC-CE",
    nav: {
      home: "Home",
      about: "About",
      war_crimes: "War Crimes",
      terror_crimes: "Terror Organizations",
      monitoring: "Monitoring",
      studies: "Studies & Reports",
      analysis: "Analysis",
      news: "News",
      director_message: "Director's Note",
      media: "Media Library",
      publications: "Publications",
      contact: "Contact",
      admin: "Admin",
    },
    home: {
      eyebrow: "Research . Documentation . Strategic Analysis",
      hero_title: "Authoritative research on security, counter-terrorism and counter-extremism in the Middle East.",
      hero_sub: "An independent center documenting violations, monitoring extremist activity, and producing strategic analysis for institutions, media, and decision-makers.",
      cta_explore: "Explore Research",
      cta_studies: "Latest Studies",
      latest_reports: "Latest Reports",
      latest_news: "Breaking & Latest News",
      featured_analysis: "Featured Analysis",
      director_block: "Weekly Note from the Director",
      view_all: "View all",
      read_more: "Read",
      see_archive: "Open archive",
      latest_publications: "Latest Publications",
      latest_publications_sub: "The seven most recent reports across all research tracks.",
    },
    sections: {
      war_crimes_title: "Documentation of War Crimes & Violations",
      war_crimes_sub: "Country-by-country archive of documented violations, supported by visual and textual evidence.",
      terror_crimes_title: "Crimes of Terrorist Organizations",
      terror_crimes_sub: "Reports on ISIS, Al-Qaeda, IRGC-linked networks, Hezbollah, and other extremist actors operating across the region.",
      monitoring_title: "Monitoring Terrorist Activities",
      monitoring_sub: "Field-level observation, geo-tagged incident bulletins, and pattern analysis across the Middle East.",
      studies_title: "Research Studies & Reports",
      studies_sub: "In-depth studies, strategic assessments, and downloadable reports for institutional and academic use.",
      analysis_title: "Analysis",
      analysis_sub: "Political and security analysis, regional outlooks, and forward-looking assessments.",
      news_title: "News",
      news_sub: "Breaking, security, and Middle East developments curated by the research team.",
      director_title: "Weekly Message from the Director",
      director_sub: "A weekly editorial reading the regional threat landscape.",
      media_title: "Media Library",
      media_sub: "Visual archive of imagery, short documentary clips, and interviews.",
      publications_title: "Publications & Releases",
      publications_sub: "Periodic bulletins, monthly reports, and downloadable studies.",
      about_title: "About the Center",
      about_sub: "Who we are, our mission, and how we work.",
      contact_title: "Contact",
      contact_sub: "Reach the Center for collaboration, media, or institutional partnerships.",
    },
    about: {
      who_we_are_h: "Who We Are",
      who_we_are: "MESC-CE is an independent research center focused on security studies, counter-terrorism, counter-extremism, war-crimes documentation, and strategic analysis of the Middle East. We serve international institutions, European organizations, media agencies, and academic centers.",
      vision_h: "Vision",
      vision: "To be a reference platform for evidence-based research on Middle East security, building bridges between rigorous documentation and informed policy.",
      mission_h: "Mission",
      mission: "We document violations, monitor extremist activity, and produce strategic, multi-language analysis grounded in open-source verification.",
      objectives_h: "Objectives",
      objectives: [
        "Document war crimes and human rights violations across the region.",
        "Monitor and analyse terrorist and extremist activity.",
        "Publish strategic studies, intelligence-grade reports, and forward-looking assessments.",
        "Make rigorous research accessible in Arabic, English, and French.",
      ],
      areas_h: "Areas of Work",
      areas: ["Counter-terrorism", "Counter-extremism", "Human rights documentation", "Geopolitical analysis", "Field monitoring"],
      team_h: "Advisory Board",
      team_sub: "A multidisciplinary network of researchers, former practitioners, and regional experts.",
    },
    filters: {
      all: "All",
      country: "Country",
      organization: "Organization",
      region: "Region",
      violation_type: "Violation type",
      reset: "Reset filters",
      search_placeholder: "Search reports, countries, organizations…",
    },
    article: {
      published: "Published",
      category: "Category",
      country: "Country",
      organization: "Organization",
      region: "Region",
      violation: "Violation",
      responsible: "Responsible party",
      tags: "Tags",
      share: "Share",
      share_link_copied: "Share link copied — preview will show image & title on WhatsApp / Twitter / LinkedIn",
      copy_share_link: "Copy share link (with rich preview)",
      views_label: "views",
      download_pdf: "Download PDF",
      attachments: "Attachments",
      gallery: "Gallery",
      videos: "Videos",
      back: "Back to listing",
    },
    contact: {
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sent: "Your message has been received. Thank you.",
      newsletter_h: "Newsletter",
      newsletter_sub: "Receive periodic bulletins.",
      newsletter_placeholder: "your.email@institution.org",
      subscribe: "Subscribe",
      subscribed: "Subscribed. Thank you.",
      address_h: "Address",
      email_h: "Email",
      social_h: "Follow",
    },
    admin: {
      dashboard: "Dashboard",
      articles: "Articles",
      media: "Media",
      contact_inbox: "Contact inbox",
      newsletter: "Newsletter",
      logout: "Logout",
      login: "Sign in",
      email: "Email",
      password: "Password",
      invalid_credentials: "Invalid credentials",
      welcome: "Welcome back",
      total_articles: "Total articles",
      published: "Published",
      drafts: "Drafts",
      media_files: "Media files",
      messages: "Messages",
      subscribers: "Subscribers",
      new_article: "New article",
      edit: "Edit",
      delete: "Delete",
      auto_translate: "AI translate",
      summarize: "Summarize",
      compose: "AI compose",
      save: "Save",
      saved: "Saved",
      title: "Title",
      summary: "Summary",
      content: "Content (rich text)",
      slug: "Slug (auto if empty)",
      category: "Category",
      country: "Country",
      organization: "Organization",
      region: "Region",
      violation_type: "Violation type",
      responsible_party: "Responsible party",
      tags: "Tags (comma separated)",
      featured: "Featured",
      breaking: "Breaking",
      status: "Status",
      published_status: "Published",
      draft: "Draft",
      featured_image: "Featured image URL",
      gallery_images: "Gallery image URLs (one per line)",
      videos: "Video URLs (one per line)",
      pdfs: "PDF attachments (name|url, one per line)",
      source_lang: "Source language",
      upload: "Upload file",
      uploaded: "Uploaded",
      copy_url: "Copy URL",
    },
    common: {
      lang_label: "Language",
      loading: "Loading…",
      no_results: "No results",
      filter: "Filter",
      apply: "Apply",
      cancel: "Cancel",
      try_again: "Try again",
      ai_smart_search: "AI smart search",
    },
    categories: {
      war_crime: "War Crimes",
      terror_crime: "Terrorist Organizations",
      monitoring: "Monitoring",
      study: "Studies & Reports",
      analysis: "Analysis",
      news: "News",
      director_message: "Director's Note",
      publication: "Publications",
    },
  },

  ar: {
    site_name: "مركز الشرق الأوسط للدراسات الأمنية ومكافحة التطرف",
    site_short: "MESC-CE",
    nav: {
      home: "الرئيسية",
      about: "عن المركز",
      war_crimes: "جرائم الحرب",
      terror_crimes: "المنظمات الإرهابية",
      monitoring: "الرصد الميداني",
      studies: "الدراسات والتقارير",
      analysis: "التحليلات",
      news: "الأخبار",
      director_message: "رسالة المدير",
      media: "المكتبة الإعلامية",
      publications: "المنشورات",
      contact: "اتصل بنا",
      admin: "لوحة الإدارة",
    },
    home: {
      eyebrow: "بحث . توثيق . تحليل استراتيجي",
      hero_title: "بحث مرجعي حول الأمن ومكافحة الإرهاب والتطرف في الشرق الأوسط.",
      hero_sub: "مركز مستقل يوثّق الانتهاكات ويرصد النشاط المتطرف وينتج تحليلاً استراتيجياً للمؤسسات والإعلام وصنّاع القرار.",
      cta_explore: "استكشاف الأبحاث",
      cta_studies: "أحدث الدراسات",
      latest_reports: "أحدث التقارير",
      latest_news: "أخبار عاجلة وحديثة",
      featured_analysis: "تحليلات مختارة",
      director_block: "الرسالة الأسبوعية للمدير",
      view_all: "عرض الكل",
      read_more: "قراءة",
      see_archive: "فتح الأرشيف",
      latest_publications: "أحدث المنشورات",
      latest_publications_sub: "آخر سبع مواد منشورة عبر جميع محاور البحث.",
    },
    sections: {
      war_crimes_title: "توثيق جرائم الحرب والانتهاكات",
      war_crimes_sub: "أرشيف موثق دولة بدولة للانتهاكات الموثقة، مدعوم بأدلة بصرية ونصية.",
      terror_crimes_title: "جرائم المنظمات الإرهابية",
      terror_crimes_sub: "تقارير عن داعش، القاعدة، الشبكات المرتبطة بالحرس الثوري الإيراني، حزب الله، وسائر الفاعلين المتطرفين في المنطقة.",
      monitoring_title: "رصد النشاط الإرهابي",
      monitoring_sub: "ملاحظات ميدانية ونشرات حوادث محددة جغرافياً وتحليل أنماط في الشرق الأوسط.",
      studies_title: "الدراسات والتقارير البحثية",
      studies_sub: "دراسات معمّقة وتقييمات استراتيجية وتقارير قابلة للتنزيل للاستخدام المؤسسي والأكاديمي.",
      analysis_title: "تحليلات",
      analysis_sub: "تحليلات سياسية وأمنية واستشرافات إقليمية.",
      news_title: "أخبار",
      news_sub: "أخبار عاجلة وأمنية وتطورات الشرق الأوسط ينتقيها فريق البحث.",
      director_title: "الرسالة الأسبوعية للمدير",
      director_sub: "افتتاحية أسبوعية تقرأ المشهد الأمني الإقليمي.",
      media_title: "المكتبة الإعلامية",
      media_sub: "أرشيف بصري للصور والمقاطع التوثيقية القصيرة والمقابلات.",
      publications_title: "المنشورات والإصدارات",
      publications_sub: "نشرات دورية وتقارير شهرية ودراسات قابلة للتنزيل.",
      about_title: "عن المركز",
      about_sub: "من نحن، رسالتنا، وكيف نعمل.",
      contact_title: "اتصل بنا",
      contact_sub: "تواصل مع المركز للتعاون أو الإعلام أو الشراكات المؤسسية.",
    },
    about: {
      who_we_are_h: "من نحن",
      who_we_are: "مركز MESC-CE مركز بحثي مستقل متخصص في الدراسات الأمنية ومكافحة الإرهاب والتطرف وتوثيق جرائم الحرب والتحليل الاستراتيجي للشرق الأوسط. نخدم المؤسسات الدولية والمنظمات الأوروبية والوكالات الإعلامية والمراكز الأكاديمية.",
      vision_h: "الرؤية",
      vision: "أن نكون منصة مرجعية للبحث القائم على الأدلة في الأمن الشرق أوسطي، نبني جسوراً بين التوثيق الصارم والسياسات المستنيرة.",
      mission_h: "الرسالة",
      mission: "نوثّق الانتهاكات ونرصد النشاط المتطرف وننتج تحليلاً استراتيجياً متعدد اللغات قائماً على التحقق من المصادر المفتوحة.",
      objectives_h: "الأهداف",
      objectives: [
        "توثيق جرائم الحرب وانتهاكات حقوق الإنسان في المنطقة.",
        "رصد وتحليل النشاط الإرهابي والمتطرف.",
        "نشر دراسات استراتيجية وتقارير عالية الجودة وتقييمات استشرافية.",
        "إتاحة البحث الصارم بالعربية والإنجليزية والفرنسية.",
      ],
      areas_h: "مجالات العمل",
      areas: ["مكافحة الإرهاب", "مكافحة التطرف", "توثيق حقوق الإنسان", "التحليل الجيوسياسي", "الرصد الميداني"],
      team_h: "المجلس الاستشاري",
      team_sub: "شبكة متعددة التخصصات من الباحثين والممارسين السابقين والخبراء الإقليميين.",
    },
    filters: {
      all: "الكل",
      country: "الدولة",
      organization: "المنظمة",
      region: "المنطقة",
      violation_type: "نوع الانتهاك",
      reset: "إعادة الضبط",
      search_placeholder: "ابحث في التقارير والدول والمنظمات…",
    },
    article: {
      published: "تاريخ النشر",
      category: "التصنيف",
      country: "الدولة",
      organization: "المنظمة",
      region: "المنطقة",
      violation: "الانتهاك",
      responsible: "الجهة المسؤولة",
      tags: "وسوم",
      share: "مشاركة",
      share_link_copied: "تم نسخ رابط المشاركة — ستظهر الصورة والعنوان عند الإرسال على واتساب / تويتر / لينكدإن",
      copy_share_link: "نسخ رابط المشاركة (مع معاينة كاملة)",
      views_label: "مشاهدة",
      download_pdf: "تنزيل PDF",
      attachments: "المرفقات",
      gallery: "معرض الصور",
      videos: "مقاطع الفيديو",
      back: "العودة إلى القائمة",
    },
    contact: {
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسالة",
      send: "إرسال الرسالة",
      sent: "تم استلام رسالتك. شكراً لك.",
      newsletter_h: "النشرة البريدية",
      newsletter_sub: "تلقّى نشرات دورية.",
      newsletter_placeholder: "your.email@institution.org",
      subscribe: "اشتراك",
      subscribed: "تم الاشتراك. شكراً لك.",
      address_h: "العنوان",
      email_h: "البريد",
      social_h: "تابعنا",
    },
    admin: {
      dashboard: "لوحة التحكم",
      articles: "المقالات",
      media: "الوسائط",
      contact_inbox: "صندوق التواصل",
      newsletter: "النشرة البريدية",
      logout: "خروج",
      login: "تسجيل الدخول",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      invalid_credentials: "بيانات الدخول غير صحيحة",
      welcome: "أهلاً بعودتك",
      total_articles: "إجمالي المقالات",
      published: "المنشورة",
      drafts: "المسودّات",
      media_files: "ملفات الوسائط",
      messages: "الرسائل",
      subscribers: "المشتركون",
      new_article: "مقال جديد",
      edit: "تعديل",
      delete: "حذف",
      auto_translate: "ترجمة بالذكاء الاصطناعي",
      summarize: "تلخيص",
      compose: "مساعد التحرير",
      save: "حفظ",
      saved: "تم الحفظ",
      title: "العنوان",
      summary: "الملخّص",
      content: "المحتوى",
      slug: "الرابط (تلقائي إن ترك فارغاً)",
      category: "التصنيف",
      country: "الدولة",
      organization: "المنظمة",
      region: "المنطقة",
      violation_type: "نوع الانتهاك",
      responsible_party: "الجهة المسؤولة",
      tags: "وسوم (مفصولة بفواصل)",
      featured: "مميّز",
      breaking: "عاجل",
      status: "الحالة",
      published_status: "منشور",
      draft: "مسودّة",
      featured_image: "رابط الصورة الرئيسية",
      gallery_images: "روابط صور المعرض (سطر لكل رابط)",
      videos: "روابط الفيديو (سطر لكل رابط)",
      pdfs: "مرفقات PDF (اسم|رابط — سطر لكل مرفق)",
      source_lang: "لغة المصدر",
      upload: "رفع ملف",
      uploaded: "تم الرفع",
      copy_url: "نسخ الرابط",
    },
    common: {
      lang_label: "اللغة",
      loading: "جاري التحميل…",
      no_results: "لا توجد نتائج",
      filter: "تصفية",
      apply: "تطبيق",
      cancel: "إلغاء",
      try_again: "حاول مرة أخرى",
      ai_smart_search: "بحث ذكي",
    },
    categories: {
      war_crime: "جرائم الحرب",
      terror_crime: "المنظمات الإرهابية",
      monitoring: "الرصد",
      study: "الدراسات والتقارير",
      analysis: "التحليلات",
      news: "الأخبار",
      director_message: "رسالة المدير",
      publication: "المنشورات",
    },
  },

  fr: {
    site_name: "Centre du Moyen-Orient pour la Sécurité et la Lutte contre l'Extrémisme",
    site_short: "MESC-CE",
    nav: {
      home: "Accueil",
      about: "Le Centre",
      war_crimes: "Crimes de guerre",
      terror_crimes: "Organisations terroristes",
      monitoring: "Suivi",
      studies: "Études & Rapports",
      analysis: "Analyses",
      news: "Actualités",
      director_message: "Note du Directeur",
      media: "Médiathèque",
      publications: "Publications",
      contact: "Contact",
      admin: "Admin",
    },
    home: {
      eyebrow: "Recherche . Documentation . Analyse stratégique",
      hero_title: "Recherche de référence sur la sécurité, la lutte contre le terrorisme et l'extrémisme au Moyen-Orient.",
      hero_sub: "Un centre indépendant qui documente les violations, suit l'activité extrémiste et produit des analyses stratégiques pour les institutions, les médias et les décideurs.",
      cta_explore: "Explorer la recherche",
      cta_studies: "Dernières études",
      latest_reports: "Derniers rapports",
      latest_news: "Actualités récentes",
      featured_analysis: "Analyses à la une",
      director_block: "Note hebdomadaire du Directeur",
      view_all: "Tout voir",
      read_more: "Lire",
      see_archive: "Ouvrir l'archive",
      latest_publications: "Dernières publications",
      latest_publications_sub: "Les sept rapports les plus récents, tous axes confondus.",
    },
    sections: {
      war_crimes_title: "Documentation des crimes de guerre et violations",
      war_crimes_sub: "Archive pays par pays des violations documentées, étayée par des preuves visuelles et textuelles.",
      terror_crimes_title: "Crimes des organisations terroristes",
      terror_crimes_sub: "Rapports sur Daech, Al-Qaïda, les réseaux liés aux Gardiens de la Révolution, le Hezbollah et autres acteurs extrémistes.",
      monitoring_title: "Suivi des activités terroristes",
      monitoring_sub: "Observations de terrain, bulletins d'incidents géo-référencés et analyse des tendances au Moyen-Orient.",
      studies_title: "Études & Rapports de recherche",
      studies_sub: "Études approfondies, évaluations stratégiques et rapports téléchargeables.",
      analysis_title: "Analyses",
      analysis_sub: "Analyses politiques et sécuritaires, perspectives régionales et évaluations prospectives.",
      news_title: "Actualités",
      news_sub: "Actualités urgentes, sécuritaires et développements moyen-orientaux.",
      director_title: "Message hebdomadaire du Directeur",
      director_sub: "Un éditorial hebdomadaire sur la sécurité régionale.",
      media_title: "Médiathèque",
      media_sub: "Archives visuelles d'images, de séquences documentaires et d'entretiens.",
      publications_title: "Publications & Parutions",
      publications_sub: "Bulletins périodiques, rapports mensuels et études téléchargeables.",
      about_title: "Le Centre",
      about_sub: "Qui nous sommes, notre mission et nos méthodes.",
      contact_title: "Contact",
      contact_sub: "Contactez le Centre pour collaborations, presse ou partenariats institutionnels.",
    },
    about: {
      who_we_are_h: "Qui nous sommes",
      who_we_are: "MESC-CE est un centre de recherche indépendant dédié aux études de sécurité, à la lutte contre le terrorisme et l'extrémisme, à la documentation des crimes de guerre et à l'analyse stratégique du Moyen-Orient.",
      vision_h: "Vision",
      vision: "Devenir une plateforme de référence pour la recherche fondée sur des preuves au service des décideurs.",
      mission_h: "Mission",
      mission: "Nous documentons les violations, suivons l'activité extrémiste et produisons une analyse stratégique multilingue fondée sur la vérification en sources ouvertes.",
      objectives_h: "Objectifs",
      objectives: [
        "Documenter les crimes de guerre et violations dans la région.",
        "Suivre et analyser l'activité terroriste et extrémiste.",
        "Publier études stratégiques et évaluations prospectives.",
        "Rendre la recherche accessible en arabe, anglais et français.",
      ],
      areas_h: "Champs d'action",
      areas: ["Lutte contre le terrorisme", "Lutte contre l'extrémisme", "Documentation des droits humains", "Analyse géopolitique", "Suivi de terrain"],
      team_h: "Conseil consultatif",
      team_sub: "Un réseau pluridisciplinaire de chercheurs et experts régionaux.",
    },
    filters: {
      all: "Tous",
      country: "Pays",
      organization: "Organisation",
      region: "Région",
      violation_type: "Type de violation",
      reset: "Réinitialiser",
      search_placeholder: "Rechercher rapports, pays, organisations…",
    },
    article: {
      published: "Publié le",
      category: "Catégorie",
      country: "Pays",
      organization: "Organisation",
      region: "Région",
      violation: "Violation",
      responsible: "Partie responsable",
      tags: "Mots-clés",
      share: "Partager",
      share_link_copied: "Lien copié — l'aperçu affichera l'image et le titre sur WhatsApp / Twitter / LinkedIn",
      copy_share_link: "Copier le lien de partage (avec aperçu)",
      views_label: "vues",
      download_pdf: "Télécharger le PDF",
      attachments: "Pièces jointes",
      gallery: "Galerie",
      videos: "Vidéos",
      back: "Retour à la liste",
    },
    contact: {
      name: "Nom complet",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer le message",
      sent: "Votre message a été reçu. Merci.",
      newsletter_h: "Newsletter",
      newsletter_sub: "Recevez nos bulletins périodiques.",
      newsletter_placeholder: "votre.email@institution.org",
      subscribe: "S'abonner",
      subscribed: "Abonné. Merci.",
      address_h: "Adresse",
      email_h: "Email",
      social_h: "Suivre",
    },
    admin: {
      dashboard: "Tableau de bord",
      articles: "Articles",
      media: "Médias",
      contact_inbox: "Boîte contact",
      newsletter: "Newsletter",
      logout: "Déconnexion",
      login: "Connexion",
      email: "Email",
      password: "Mot de passe",
      invalid_credentials: "Identifiants invalides",
      welcome: "Bon retour",
      total_articles: "Articles totaux",
      published: "Publiés",
      drafts: "Brouillons",
      media_files: "Fichiers médias",
      messages: "Messages",
      subscribers: "Abonnés",
      new_article: "Nouvel article",
      edit: "Modifier",
      delete: "Supprimer",
      auto_translate: "Traduction IA",
      summarize: "Résumer",
      compose: "Assistant IA",
      save: "Enregistrer",
      saved: "Enregistré",
      title: "Titre",
      summary: "Résumé",
      content: "Contenu",
      slug: "Slug (auto si vide)",
      category: "Catégorie",
      country: "Pays",
      organization: "Organisation",
      region: "Région",
      violation_type: "Type de violation",
      responsible_party: "Partie responsable",
      tags: "Mots-clés (séparés par virgules)",
      featured: "Mis en avant",
      breaking: "Urgent",
      status: "Statut",
      published_status: "Publié",
      draft: "Brouillon",
      featured_image: "URL image principale",
      gallery_images: "URLs galerie (une par ligne)",
      videos: "URLs vidéo (une par ligne)",
      pdfs: "PDF (nom|url, une par ligne)",
      source_lang: "Langue source",
      upload: "Téléverser",
      uploaded: "Téléversé",
      copy_url: "Copier l'URL",
    },
    common: {
      lang_label: "Langue",
      loading: "Chargement…",
      no_results: "Aucun résultat",
      filter: "Filtrer",
      apply: "Appliquer",
      cancel: "Annuler",
      try_again: "Réessayer",
      ai_smart_search: "Recherche IA",
    },
    categories: {
      war_crime: "Crimes de guerre",
      terror_crime: "Organisations terroristes",
      monitoring: "Suivi",
      study: "Études & Rapports",
      analysis: "Analyses",
      news: "Actualités",
      director_message: "Note du Directeur",
      publication: "Publications",
    },
  },

  he: {
    site_name: "המרכז המזרח-תיכוני לחקר ביטחון ומאבק בקיצוניות",
    site_short: "MESC-CE",
    nav: {
      home: "בית",
      about: "אודות",
      war_crimes: "פשעי מלחמה",
      terror_crimes: "ארגוני טרור",
      monitoring: "ניטור",
      studies: "מחקרים ודוחות",
      analysis: "ניתוחים",
      news: "חדשות",
      director_message: "פתח דבר",
      media: "ספריית מדיה",
      publications: "פרסומים",
      contact: "צור קשר",
      admin: "ניהול",
    },
    home: {
      eyebrow: "מחקר . תיעוד . ניתוח אסטרטגי",
      hero_title: "מחקר סמכותי על ביטחון, מאבק בטרור וקיצוניות במזרח התיכון.",
      hero_sub: "מרכז עצמאי המתעד הפרות, עוקב אחר פעילות קיצונית ומפיק ניתוחים אסטרטגיים למוסדות, כלי תקשורת וקובעי מדיניות.",
      cta_explore: "חקור מחקר",
      cta_studies: "מחקרים אחרונים",
      latest_reports: "דוחות אחרונים",
      latest_news: "חדשות מתפרצות ועדכניות",
      featured_analysis: "ניתוחים נבחרים",
      director_block: "פתח דבר שבועי מהמנהל",
      view_all: "הצג הכל",
      read_more: "קרא",
      see_archive: "פתח ארכיון",
      latest_publications: "פרסומים אחרונים",
      latest_publications_sub: "שבעת הדוחות האחרונים בכל צירי המחקר.",
    },
    sections: {
      war_crimes_title: "תיעוד פשעי מלחמה והפרות",
      war_crimes_sub: "ארכיון מסודר מדינה אחר מדינה של הפרות מתועדות, מגובה בראיות חזותיות וטקסטואליות.",
      terror_crimes_title: "פשעי ארגוני טרור",
      terror_crimes_sub: "דוחות על דאעש, אל-קאעדה, רשתות הקשורות למשמרות המהפכה האיראניים, חיזבאללה ושאר גורמי קיצון באזור.",
      monitoring_title: "ניטור פעילויות טרור",
      monitoring_sub: "תצפיות שטח, עדכוני אירועים מתויגים גיאוגרפית וניתוח דפוסים במזרח התיכון.",
      studies_title: "מחקרים ודוחות",
      studies_sub: "מחקרים מעמיקים, הערכות אסטרטגיות ודוחות להורדה לשימוש מוסדי ואקדמי.",
      analysis_title: "ניתוחים",
      analysis_sub: "ניתוחים פוליטיים וביטחוניים, סקירות אזוריות והערכות צופות פני עתיד.",
      news_title: "חדשות",
      news_sub: "חדשות מתפרצות, ביטחוניות והתפתחויות במזרח התיכון.",
      director_title: "פתח דבר שבועי מהמנהל",
      director_sub: "מאמר שבועי הקורא את הסביבה הביטחונית האזורית.",
      media_title: "ספריית מדיה",
      media_sub: "ארכיון חזותי של תמונות, קטעים תיעודיים וראיונות.",
      publications_title: "פרסומים והוצאות",
      publications_sub: "עלונים תקופתיים, דוחות חודשיים ומחקרים להורדה.",
      about_title: "אודות המרכז",
      about_sub: "מי אנחנו, ייעודנו ושיטות העבודה שלנו.",
      contact_title: "צור קשר",
      contact_sub: "צור קשר עם המרכז לשיתוף פעולה, פניות תקשורת ושותפויות מוסדיות.",
    },
    about: {
      who_we_are_h: "מי אנחנו",
      who_we_are: "MESC-CE הוא מרכז מחקר עצמאי המתמקד בלימודי ביטחון, מאבק בטרור ובקיצוניות, תיעוד פשעי מלחמה וניתוח אסטרטגי של המזרח התיכון.",
      vision_h: "חזון",
      vision: "להיות פלטפורמה ייחוסית למחקר מבוסס-עובדות בנושא ביטחון במזרח התיכון.",
      mission_h: "ייעוד",
      mission: "אנו מתעדים הפרות, עוקבים אחר פעילות קיצונית ומפיקים ניתוח אסטרטגי רב-לשוני המבוסס על אימות ממקורות פתוחים.",
      objectives_h: "יעדים",
      objectives: [
        "תיעוד פשעי מלחמה והפרות זכויות אדם באזור.",
        "ניטור וניתוח של פעילות טרור וקיצוניות.",
        "פרסום מחקרים אסטרטגיים, דוחות מודיעין והערכות צופות פני עתיד.",
        "הנגשת מחקר קפדני בערבית, אנגלית וצרפתית.",
      ],
      areas_h: "תחומי פעילות",
      areas: ["מאבק בטרור", "מאבק בקיצוניות", "תיעוד זכויות אדם", "ניתוח גיאופוליטי", "ניטור שטח"],
      team_h: "חבר היועצים",
      team_sub: "רשת בין-תחומית של חוקרים, אנשי מקצוע לשעבר ומומחים אזוריים.",
    },
    filters: {
      all: "הכל",
      country: "מדינה",
      organization: "ארגון",
      region: "אזור",
      violation_type: "סוג הפרה",
      reset: "אפס מסננים",
      search_placeholder: "חפש דוחות, מדינות, ארגונים…",
    },
    article: {
      published: "פורסם",
      category: "קטגוריה",
      country: "מדינה",
      organization: "ארגון",
      region: "אזור",
      violation: "הפרה",
      responsible: "גורם אחראי",
      tags: "תגיות",
      share: "שתף",
      share_link_copied: "הקישור הועתק — תצוגה מקדימה תכלול תמונה וכותרת ב-WhatsApp / Twitter / LinkedIn",
      copy_share_link: "העתק קישור לשיתוף (עם תצוגה מקדימה)",
      views_label: "צפיות",
      download_pdf: "הורד PDF",
      attachments: "קבצים מצורפים",
      gallery: "גלריה",
      videos: "סרטונים",
      back: "חזרה לרשימה",
    },
    contact: {
      name: "שם מלא",
      email: "דוא\"ל",
      subject: "נושא",
      message: "הודעה",
      send: "שלח הודעה",
      sent: "הודעתך התקבלה. תודה.",
      newsletter_h: "ניוזלטר",
      newsletter_sub: "קבל עלונים תקופתיים.",
      newsletter_placeholder: "your.email@institution.org",
      subscribe: "הירשם",
      subscribed: "נרשמת. תודה.",
      address_h: "כתובת",
      email_h: "דוא\"ל",
      social_h: "עקבו",
    },
    admin: {
      dashboard: "לוח בקרה",
      articles: "מאמרים",
      media: "מדיה",
      contact_inbox: "תיבת פניות",
      newsletter: "ניוזלטר",
      logout: "התנתק",
      login: "התחברות",
      email: "דוא\"ל",
      password: "סיסמה",
      invalid_credentials: "פרטי הזדהות שגויים",
      welcome: "ברוך שובך",
      total_articles: "סך מאמרים",
      published: "פורסמו",
      drafts: "טיוטות",
      media_files: "קבצי מדיה",
      messages: "הודעות",
      subscribers: "מנויים",
      new_article: "מאמר חדש",
      edit: "ערוך",
      delete: "מחק",
      auto_translate: "תרגום AI",
      summarize: "סכם",
      compose: "כתיבת AI",
      save: "שמור",
      saved: "נשמר",
      title: "כותרת",
      summary: "תקציר",
      content: "תוכן",
      slug: "Slug (אוטומטי אם ריק)",
      category: "קטגוריה",
      country: "מדינה",
      organization: "ארגון",
      region: "אזור",
      violation_type: "סוג הפרה",
      responsible_party: "גורם אחראי",
      tags: "תגיות (מופרדות בפסיקים)",
      featured: "מומלץ",
      breaking: "מתפרץ",
      status: "סטטוס",
      published_status: "פורסם",
      draft: "טיוטה",
      featured_image: "כתובת תמונה ראשית",
      gallery_images: "כתובות גלריה (אחת בשורה)",
      videos: "כתובות וידאו (אחת בשורה)",
      pdfs: "קובצי PDF (שם|כתובת — אחד בשורה)",
      source_lang: "שפת מקור",
      upload: "העלה קובץ",
      uploaded: "הועלה",
      copy_url: "העתק URL",
    },
    common: {
      lang_label: "שפה",
      loading: "טוען…",
      no_results: "אין תוצאות",
      filter: "סנן",
      apply: "החל",
      cancel: "בטל",
      try_again: "נסה שוב",
      ai_smart_search: "חיפוש AI",
    },
    categories: {
      war_crime: "פשעי מלחמה",
      terror_crime: "ארגוני טרור",
      monitoring: "ניטור",
      study: "מחקרים ודוחות",
      analysis: "ניתוחים",
      news: "חדשות",
      director_message: "פתח דבר",
      publication: "פרסומים",
    },
  },

  de: {
    site_name: "Nahost-Zentrum für Sicherheit und Extremismusbekämpfung",
    site_short: "MESC-CE",
    nav: {
      home: "Startseite",
      about: "Über uns",
      war_crimes: "Kriegsverbrechen",
      terror_crimes: "Terrororganisationen",
      monitoring: "Beobachtung",
      studies: "Studien & Berichte",
      analysis: "Analysen",
      news: "Nachrichten",
      director_message: "Notiz des Direktors",
      media: "Mediathek",
      publications: "Publikationen",
      contact: "Kontakt",
      admin: "Admin",
    },
    home: {
      eyebrow: "Forschung . Dokumentation . Strategische Analyse",
      hero_title: "Maßgebliche Forschung zu Sicherheit, Terrorismus- und Extremismusbekämpfung im Nahen Osten.",
      hero_sub: "Ein unabhängiges Zentrum, das Verstöße dokumentiert, extremistische Aktivitäten beobachtet und strategische Analysen für Institutionen, Medien und Entscheidungsträger erstellt.",
      cta_explore: "Forschung erkunden",
      cta_studies: "Aktuelle Studien",
      latest_reports: "Aktuelle Berichte",
      latest_news: "Aktuelle Eilmeldungen",
      featured_analysis: "Ausgewählte Analysen",
      director_block: "Wöchentliche Notiz des Direktors",
      view_all: "Alle anzeigen",
      read_more: "Lesen",
      see_archive: "Archiv öffnen",
      latest_publications: "Neueste Veröffentlichungen",
      latest_publications_sub: "Die sieben aktuellsten Berichte aus allen Forschungsbereichen.",
    },
    sections: {
      war_crimes_title: "Dokumentation von Kriegsverbrechen und Verstößen",
      war_crimes_sub: "Länderbezogenes Archiv dokumentierter Verstöße, gestützt auf visuelle und textuelle Beweise.",
      terror_crimes_title: "Verbrechen terroristischer Organisationen",
      terror_crimes_sub: "Berichte über IS, Al-Qaida, IRGC-nahe Netzwerke, Hisbollah und weitere extremistische Akteure in der Region.",
      monitoring_title: "Beobachtung terroristischer Aktivitäten",
      monitoring_sub: "Feldbeobachtungen, geo-tagged Vorfallsberichte und Musteranalysen im Nahen Osten.",
      studies_title: "Studien & Forschungsberichte",
      studies_sub: "Tiefgehende Studien, strategische Bewertungen und herunterladbare Berichte für institutionelle und akademische Nutzung.",
      analysis_title: "Analysen",
      analysis_sub: "Politische und sicherheitspolitische Analysen, regionale Ausblicke und vorausschauende Bewertungen.",
      news_title: "Nachrichten",
      news_sub: "Eilmeldungen, sicherheitsrelevante und nahöstliche Entwicklungen.",
      director_title: "Wöchentliche Notiz des Direktors",
      director_sub: "Wöchentlicher Leitartikel zur regionalen Sicherheitslage.",
      media_title: "Mediathek",
      media_sub: "Visuelles Archiv mit Bildern, kurzen Dokumentarclips und Interviews.",
      publications_title: "Publikationen & Veröffentlichungen",
      publications_sub: "Periodische Bulletins, monatliche Berichte und herunterladbare Studien.",
      about_title: "Über das Zentrum",
      about_sub: "Wer wir sind, unsere Mission und unsere Arbeitsweise.",
      contact_title: "Kontakt",
      contact_sub: "Kontaktieren Sie das Zentrum für Kooperation, Medien oder institutionelle Partnerschaften.",
    },
    about: {
      who_we_are_h: "Wer wir sind",
      who_we_are: "MESC-CE ist ein unabhängiges Forschungszentrum für Sicherheitsstudien, Terrorismus- und Extremismusbekämpfung, Dokumentation von Kriegsverbrechen und strategische Analyse des Nahen Ostens.",
      vision_h: "Vision",
      vision: "Eine Referenzplattform für evidenzbasierte Forschung zur Sicherheit im Nahen Osten zu sein.",
      mission_h: "Mission",
      mission: "Wir dokumentieren Verstöße, beobachten extremistische Aktivitäten und erstellen mehrsprachige strategische Analysen auf Basis von Open-Source-Verifikation.",
      objectives_h: "Ziele",
      objectives: [
        "Dokumentation von Kriegsverbrechen und Menschenrechtsverletzungen.",
        "Beobachtung und Analyse terroristischer und extremistischer Aktivitäten.",
        "Veröffentlichung strategischer Studien und vorausschauender Bewertungen.",
        "Zugängliche Forschung in Arabisch, Englisch und Französisch.",
      ],
      areas_h: "Arbeitsgebiete",
      areas: ["Terrorismusbekämpfung", "Extremismusbekämpfung", "Menschenrechtsdokumentation", "Geopolitische Analyse", "Feldbeobachtung"],
      team_h: "Beirat",
      team_sub: "Ein interdisziplinäres Netzwerk aus Forschern und regionalen Experten.",
    },
    filters: {
      all: "Alle",
      country: "Land",
      organization: "Organisation",
      region: "Region",
      violation_type: "Verstoßart",
      reset: "Filter zurücksetzen",
      search_placeholder: "Berichte, Länder, Organisationen suchen…",
    },
    article: {
      published: "Veröffentlicht",
      category: "Kategorie",
      country: "Land",
      organization: "Organisation",
      region: "Region",
      violation: "Verstoß",
      responsible: "Verantwortliche Partei",
      tags: "Schlagwörter",
      share: "Teilen",
      share_link_copied: "Link kopiert — Vorschau zeigt Bild und Titel auf WhatsApp / Twitter / LinkedIn",
      copy_share_link: "Teilen-Link kopieren (mit Vorschau)",
      views_label: "Aufrufe",
      download_pdf: "PDF herunterladen",
      attachments: "Anhänge",
      gallery: "Galerie",
      videos: "Videos",
      back: "Zurück zur Liste",
    },
    contact: {
      name: "Vollständiger Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      send: "Nachricht senden",
      sent: "Ihre Nachricht wurde empfangen. Vielen Dank.",
      newsletter_h: "Newsletter",
      newsletter_sub: "Periodische Bulletins erhalten.",
      newsletter_placeholder: "ihre.email@institution.org",
      subscribe: "Abonnieren",
      subscribed: "Abonniert. Vielen Dank.",
      address_h: "Adresse",
      email_h: "E-Mail",
      social_h: "Folgen",
    },
    admin: {
      dashboard: "Dashboard",
      articles: "Artikel",
      media: "Medien",
      contact_inbox: "Kontakt-Postfach",
      newsletter: "Newsletter",
      logout: "Abmelden",
      login: "Anmelden",
      email: "E-Mail",
      password: "Passwort",
      invalid_credentials: "Ungültige Anmeldedaten",
      welcome: "Willkommen zurück",
      total_articles: "Artikel insgesamt",
      published: "Veröffentlicht",
      drafts: "Entwürfe",
      media_files: "Mediendateien",
      messages: "Nachrichten",
      subscribers: "Abonnenten",
      new_article: "Neuer Artikel",
      edit: "Bearbeiten",
      delete: "Löschen",
      auto_translate: "KI-Übersetzung",
      summarize: "Zusammenfassen",
      compose: "KI-Assistent",
      save: "Speichern",
      saved: "Gespeichert",
      title: "Titel",
      summary: "Zusammenfassung",
      content: "Inhalt",
      slug: "Slug (auto wenn leer)",
      category: "Kategorie",
      country: "Land",
      organization: "Organisation",
      region: "Region",
      violation_type: "Verstoßart",
      responsible_party: "Verantwortliche Partei",
      tags: "Schlagwörter (kommagetrennt)",
      featured: "Hervorgehoben",
      breaking: "Eilmeldung",
      status: "Status",
      published_status: "Veröffentlicht",
      draft: "Entwurf",
      featured_image: "URL des Hauptbildes",
      gallery_images: "Galerie-URLs (eine pro Zeile)",
      videos: "Video-URLs (eine pro Zeile)",
      pdfs: "PDFs (Name|URL, eine pro Zeile)",
      source_lang: "Quellsprache",
      upload: "Datei hochladen",
      uploaded: "Hochgeladen",
      copy_url: "URL kopieren",
    },
    common: {
      lang_label: "Sprache",
      loading: "Wird geladen…",
      no_results: "Keine Ergebnisse",
      filter: "Filter",
      apply: "Anwenden",
      cancel: "Abbrechen",
      try_again: "Erneut versuchen",
      ai_smart_search: "KI-Suche",
    },
    categories: {
      war_crime: "Kriegsverbrechen",
      terror_crime: "Terrororganisationen",
      monitoring: "Beobachtung",
      study: "Studien & Berichte",
      analysis: "Analysen",
      news: "Nachrichten",
      director_message: "Notiz des Direktors",
      publication: "Publikationen",
    },
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "he", label: "עברית", dir: "rtl" },
  { code: "de", label: "Deutsch", dir: "ltr" },
];

export default UI;
